// Module
var code = "<button data-ref=button>{{name}}</button>";
// Exports
export default code;